<script>
import axios from 'axios';
import { consultingApiUrl, consultingApiKey } from '../../variables';
import AnswerRatingStart from './AnswerRatingStart';
import AnswerRatingVerbesserung from './AnswerRatingVerbesserung';

export default {
  name: 'AnswerRating',
  components: {
    AnswerRatingStart,
    AnswerRatingVerbesserung,
  },
  props: {
    conversationItemId: Number,
  },
  data() {
    return {
      currentStep: 0,
      totalSteps: 2, // icluding start
      containerHeight: 'auto',
      formData: {}
    };
  },
  mounted() {
    // calc initial height
    this.setContainerHeight();
    // recalc on window resize
    window.addEventListener('resize', this.setContainerHeight);
  },
  methods: {
    onStart(value) {
      const data = {'Zufriedenheit': value};
      this.onNextStep(data);
    },
    async onNextStep(data) {
      // add data to form data
      if (data) {
        for (const [key, value] of Object.entries(data)) {
          this.formData[key] = value;
        }
      }

      // flat arrays to comma seperated strings
      let ratings = {
        ...this.formData
      };
      for (const [key, value] of Object.entries(ratings)) {
        if (Array.isArray(value)) {
          ratings[key] = value.join(', ');
        }
      }

      // send post data
      await axios.post(
        `${consultingApiUrl}/conversation-items/rating`, 
        {
          conversation_item_id: this.conversationItemId, 
          ...ratings
        },
        {
          headers: {
            Authorization: `Bearer ${consultingApiKey}`
          }
        }
      );
      
      // increase step
      this.currentStep++;

      // recalc height
      this.$nextTick(() => {
        this.setContainerHeight();
      });
    },
    setContainerHeight() {
      if (!this.$refs.container) return;
      this.containerHeight = `${this.$refs.container.offsetHeight}px`;
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.setContainerHeight);
  }
};
</script>

<template>
  <section
    class="answer-rating"
    v-bind:class="{
      'answer-rating--started': currentStep > 0,
      'answer-rating--ended': currentStep === totalSteps,
    }"
    v-bind:style="{ height: containerHeight }"
  >

    <answer-rating-start v-on:nextStep="onNextStep" v-if="currentStep === 0" />

    <div ref="container" class="answer-rating__body" v-else>
      <div class="answer-rating__icon">
        <img class="answer-rating__icon-svg" src="../../assets/images/ico-survey.svg" alt="Umfrage">
      </div>
      <div class="answer-rating__content">
        <form
          action=""
          class="answer-rating__form form form--simplified"
          v-if="currentStep < totalSteps"
        >
          <answer-rating-verbesserung v-on:nextStep="onNextStep" v-on:resize="setContainerHeight" v-if="currentStep === 1" />
        </form>

        <div class="answer-rating__step" v-if="currentStep === totalSteps">
          <div class="survey-step__body">
            <p class="survey-step__paragraph survey-step__paragraph--hero">
              Vielen Dank, dass Sie sich die Zeit genommen haben. Die
              Informationen werden ausschliesslich zur Verbesserung unserer
              Plattform verwendet.
            </p>
          </div>
        </div>
      </div>
    </div>
    
  </section>
</template>

<style lang="scss">
.answer-rating {
  margin-top: 1.6rem;
  transition: height 150ms;
}

.answer-rating--started {
  background-color: $color-card-background;
}

.answer-rating:not(.answer-rating--ended).answer-rating--started .answer-rating__body {
  min-height: 32rem;
}

.answer-rating__body {
  display: flex;
  overflow: hidden;
  padding: 3.2rem;

  @include breakpoint('xs-down') {
    display: block;
  }
}

.answer-rating__icon {
  flex: 0 0 9.6rem;
  margin: 0.8rem 4rem 1.2rem 0;
}

.answer-rating__icon-svg {
  width: 100%;
  max-width: 9.6rem;
}

.answer-rating__content {
  flex: 1 1 auto;
}

.answer-rating__form {
  height: 100%;
}
</style>
